<template>
  <header class="flex items-center py-4" :class="free ? 'justify-end sm:justify-between sm:ml-0 ml-16 mr-2 sm:mr-0' : 'justify-end'">
    <FreeUploadsCounter v-if="free" />
    <div v-else>&nbsp;</div>
    <div class="flex gap-2">
      <!-- <Button v-if="!isMobile && !isFree" type="link" icon="general.newRecording" data-testid="viewer-header-new-recording-button">
        <span class="hidden md:inline">New Recording</span>
      </Button>
      <Button type="link" icon="general.uploadCloud" data-testid="viewer-header-upload-button">
        <span class="hidden md:inline">Upload</span>
      </Button> -->

      <ImpersonationIndicator />
      <AdminMenu v-if="isSystemAdmin" />
      <Notifications />
    </div>
  </header>
</template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import FreeUploadsCounter from './FreeUploadsCounter.vue';
import Notifications from './notifications/Notifications.vue';
import AdminMenu from './AdminMenu.vue';
import ImpersonationIndicator from './ImpersonationIndicator.vue';
import { useOrganizationStore } from '@/store/useOrganizationStore';
import { useUserStore } from '@/store/useUserStore';
// import { useMobileDetection } from '@/composables/useMobileDetection';
// import { Button } from '@/storybook/button';

const { free } = storeToRefs(useOrganizationStore());
const { isSystemAdmin } = storeToRefs(useUserStore());

// const { isMobile } = useMobileDetection();
</script>
